/*
  pdp-mobile-order.js
  ───────────────────
  Figma mobile flow places the Tilbehør/Reservedele band INSIDE the buy
  box, after the tax note and before the trust items — on desktop it is
  a full-width band below the hero grid (and must stay outside that
  grid, or the sticky gallery slides under it). Same DOM node, relocated
  per breakpoint; the carousel element guards against re-init on move.
*/
(function () {
  if (window.__ggmPdpMobileOrder) return;
  window.__ggmPdpMobileOrder = true;

  var mq = window.matchMedia('(max-width: 1024px)');

  function directChildOf(wrapper, el) {
    while (el && el.parentElement && el.parentElement !== wrapper) {
      el = el.parentElement;
    }
    return el && el.parentElement === wrapper ? el : null;
  }

  function place() {
    var band = document.querySelector('.pm__upsell-band');
    if (!band) return;

    /* global.js relocates .shopify-block.pm__upsell before the SEO
       dropdown on mobile at DOMContentLoaded (the OLD design's mobile
       placement) — reclaim it into the band before positioning. */
    var block = document.querySelector('.shopify-block.pm__upsell');
    if (block && block.parentElement !== band) {
      band.appendChild(block);
    }

    if (mq.matches) {
      var wrapper = document.querySelector('.pm__information-wrapper');
      if (!wrapper) return;
      var target =
        wrapper.querySelector('.pm__trust-item') ||
        wrapper.querySelector('.pm__downloads') ||
        wrapper.querySelector('.shipping-info');
      if (!target) {
        if (band.parentElement !== wrapper) wrapper.appendChild(band);
        return;
      }
      var anchor = directChildOf(wrapper, target);
      if (!anchor) return;
      /* shipping-info fallback anchors ABOVE the band, not below */
      var before = target.classList.contains('shipping-info') ? anchor.nextElementSibling : anchor;
      if (band.nextElementSibling !== before || band.parentElement !== wrapper) {
        wrapper.insertBefore(band, before);
      }
    } else {
      var hero = document.querySelector('.pm__content-wrapper');
      if (hero && hero.parentNode && hero.nextElementSibling !== band) {
        hero.parentNode.insertBefore(band, hero.nextSibling);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
  window.addEventListener('load', place);

  if (mq.addEventListener) {
    mq.addEventListener('change', place);
  } else if (mq.addListener) {
    mq.addListener(place);
  }
})();
